
require('./bootstrap');
require('bootstrap');
require('bootstrap-modal');
require('bootstrap-datepicker');
require('pc-bootstrap4-datetimepicker');
require('datatables.net-bs4');
require('jquery-mask-plugin');


global.$ = global.jQuery = require('jquery');
window.Dropzone = require('dropzone');
window.Compressor = require('compressorjs');
Dropzone.autoDiscover = false;

import features from "./features";
import customer from "./customer";
import auth from "./auth";
import masks from "./masks";
import event from "./admin/event";
import Slider from "./slider";
import faq from "./faq";
import RunningLine from "./components/RunningLine";
import { SimpleSectionSwitcher } from "./components/SimpleSectionSwitcher";
import emailNotifications from './email-templating/email-notifications';
import homePage from "./static-pages/home-page";
import helpCenter from "./static-pages/help-center";


$(document).ready(function () {
    $('#login-form-modal, #register-form-modal').find('.placeholder-logo.password').click(function() {
        // const input_p = $(this).parent().find('#loginPassword');
        const input_p = $(this).parent().find('input');
        if (input_p.attr('type') == 'password') {
            input_p.attr('type', 'text');
        }else{
            input_p.attr('type', 'password');
        }
    });
    $('#login-form-modal').find('.forgot-password-btn').click(function() {
        $('#reset-password-modal').modal('show');
        if ($('#login-form-modal').find('#loginEmail').val() !== '') {
            $('#reset-password-modal').find('#resetEmail').val($('#login-form-modal').find('#loginEmail').val());
        }
        $('#login-form-modal').modal('hide');
    });
    $('#register-form-modal').on('hide.bs.modal', function() {
        if (location.pathname.includes('/register')) {
            location.href = '/';
        }
    });
    $('#login-form-modal').find('.sign-up-btn').click(function() {
        const email = $('#login-form-modal').find('#loginEmail').val();
        $('#register-form-modal').find('#email').val(email);
        $('#register-form-modal').modal('show');
        $('#login-form-modal').modal('hide');
    });
    $('#reset-password-modal').find('#back-to-login').click(function() {
        $('#reset-password-modal').modal('hide');
        $('#login-form-modal').modal('show');
        $('#reset-password-modal').find('.reset-container').removeClass('d-none');
        $('#reset-password-modal').find('.success-container').addClass('d-none');
        $('#reset-password-modal').find('.modal-header').removeClass('d-none');
    });
    $('#reset-password-modal').find('#reset-password').click(function() {
        const data = {
            email: $('#reset-password-modal').find('#resetEmail').val(),
        };
        $.ajax({
            method: 'POST',
            url: '/forget-password',
            data: data,
            success: (response) => {

                $('#reset-password-modal').find('.reset-container').addClass('d-none');
                $('#reset-password-modal').find('.success-container').removeClass('d-none');
                $('#reset-password-modal').find('.modal-header').addClass('d-none');
            }
        });
    });
    customer.init();
    features.init();
    faq.init();
    auth.init();
    masks.init();
    event.init();
    emailNotifications.init();
    homePage.init();
    helpCenter.init();
    Slider.init();
    SimpleSectionSwitcher.init();
    RunningLine.init();
});
